import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
export const ErrorFallbackComponent = ({ error }) => {
    return (_jsxs("div", { css: css `
        background-color: white;
        color: #800;
        font-family: sans-serif;
      `, children: [_jsx("div", { css: css `
          padding: 10px;
          background-color: #ddd;
          font-weight: bold;
          font-size: 20px;
        `, children: "Error" }), _jsx("div", { css: css `
          padding: 10px;
          background-color: #eee;
          font-weight: bold;
          font-size: 20px;
        `, children: error.message }), error.stack && (_jsx("div", { css: css `
            padding: 10px;
            font-size: 16px;
            white-space: pre;
          `, children: error.stack }))] }));
};
